<div class="current-plan" *ngIf="content && currentSubscription">
  <div class="current-plan-box">
    <div class="logo-container">
      <img
        class="logo"
        src="/assets/images/compensate-logo-small-astral.svg"
        loading="lazy"
        alt=""
      />
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="currentSubscription.plan.amount === 100 && !currentSubscription.metadata.multiplier">
      {{
        content?.fields?.resources | findResource: 'settings.fullSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="currentSubscription.plan.amount === 200 && !currentSubscription.metadata.multiplier">
      {{
        content?.fields?.resources | findResource: 'settings.doubleSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="currentSubscription.metadata.multiplier === '0.5'">
      {{
        content?.fields?.resources | findResource: 'settings.halfSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="currentSubscription.metadata.multiplier === '1'">
      {{
        content?.fields?.resources | findResource: 'settings.fullSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="currentSubscription.metadata.multiplier === '1.5'">
      {{
        content?.fields?.resources | findResource: 'settings.oneAndHalfSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="currentSubscription.metadata.multiplier === '2'">
      {{
        content?.fields?.resources | findResource: 'settings.doubleSubscriptionPlanName'
      }}
    </div>
    <div class="subscription__column subscription__column--plan-name" *ngIf="currentSubscription.metadata.multiplier === '3'">
      {{
        content?.fields?.resources | findResource: 'settings.tripleSubscriptionPlanName'
      }}
    </div>
    <div class="plan-price">
      {{
        (currentSubscription.plan.amount * currentSubscription.quantity) / 100
          | currency
            : (currentSubscription.plan.currency | uppercase)
            : 'symbol-narrow'
            : '1.2-2'
            : 'fi'
      }}
      / {{ content.fields.perMonth }}
    </div>
    <div class="plan-detailed-information">
      <div class="plan-detailed-information__explanation">
        {{ content.fields.currentPlanExplanation }}
      </div>
      <div class="plan-detailed-information__link-container">
        <a
          class="plan-detailed-information__link"
          [routerLink]="content.fields.currentPlanLink"
          >{{ content.fields.currentPlanLinkText }}</a
        >
      </div>
    </div>
  </div>

  <div class="ingress">
    {{ content.fields.currentPlanIngress }}

    <ng-container *ngIf="content.fields.appButtonLinksAndImages">
      <div class="plan-buttons">
        <a
          [href]="button.fields.link"
          class="button"
          *ngFor="let button of content.fields.appButtonLinksAndImages"
        >
          <app-picture
            [source]="button.fields.image.fields.file.url"
            [alt]="button.fields.image.fields.description || ''"
            [type]="'banner'"
          >
          </app-picture>
        </a>
      </div>
    </ng-container>
  </div>
</div>
